import { useEffect, useRef, useState } from "react";

const DIGITS = "0123456789";

const prefersReducedMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const AnimatedDigit = ({
  target,
  settleAt,
}: {
  target: string;
  settleAt: number;
}) => {
  const [displayed, setDisplayed] = useState("0");
  const settled = useRef(false);

  useEffect(() => {
    if (prefersReducedMotion) {
      setDisplayed(target);
      return;
    }

    settled.current = false;
    setDisplayed("0");

    const interval = setInterval(() => {
      if (!settled.current) {
        setDisplayed(DIGITS[Math.floor(Math.random() * 10)]);
      }
    }, 50);

    const timer = setTimeout(() => {
      settled.current = true;
      clearInterval(interval);
      setDisplayed(target);
    }, settleAt);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [target, settleAt]);

  return <span>{displayed}</span>;
};

export const SplitFlap = ({
  value,
  startDelay = 0,
  className,
  style,
}: {
  value: string;
  startDelay?: number;
  className?: string;
  style?: React.CSSProperties;
}) => {
  let digitIndex = 0;
  return (
    <span className={className} style={style}>
      {value.split("").map((char, i) => {
        if (DIGITS.includes(char)) {
          const settleAt = startDelay + 400 + digitIndex * 140;
          digitIndex++;
          return <AnimatedDigit key={i} target={char} settleAt={settleAt} />;
        }
        return <span key={i}>{char}</span>;
      })}
    </span>
  );
};
